'use client'

import { SelectCheckbox, SelectMultipleCheckboxProps } from '@/shared/ui/checkbox'
import { SelectionDictionaryParams, dictionaryQueries } from '../../api'
import { Skeleton } from '@/shared/ui/skeleton'
import { arrayValues } from '@/shared/lib/helpers/array'

interface ComponentProps extends Omit<SelectMultipleCheckboxProps, 'defaultValues' | 'options'> {
  dictionary: SelectionDictionaryParams
  defaultValues?: SelectMultipleCheckboxProps['defaultValues']
  skeletonCount?: number
}

export default function Component(props: ComponentProps) {
  const { data, isLoading } = dictionaryQueries.useGet(props.dictionary)
  if (isLoading) {
    return arrayValues(props.skeletonCount || 3).map((v, i) => <Skeleton key={i} className="w-full h-10" />)
  }

  return (
    <SelectCheckbox
      idFieldName="id"
      valueFieldName="id"
      labelFieldName="name"
      checkboxProps={{
        labelProps: {
          className: 'border-none hover:bg-muted cursor-pointer text-sm',
        },
        className: 'rounded-sm',
      }}
      className="gap-1"
      {...props}
      defaultValues={props.defaultValues || []}
      options={data || []}
    />
  )
}
